export default "__VITE_ASSET__COpUUMKO__"